import React from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import useFetchAllMaps from '../../../hooks/useFetchAllMaps';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';
import { PROJECT_THUMBNAIL_PLACEHOLDER, RECENT_PROJECTS_LIMIT } from './constants';
import styles from './recentProjects.module.scss';

interface RecentMap {
  id: string;
  general?: {
    mapTitle?: string;
    thumbnailImage?: string;
  };
}

const getTextFromHtml = (html?: string) => {
  if (!html) return '';
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return (temp.textContent || temp.innerText || '').trim();
};

const RecentProjects: React.FC = () => {
  const { data: maps } = useFetchAllMaps();
  const navigate = useNavigate();
  const recentMaps: RecentMap[] = (maps ?? []).slice(0, RECENT_PROJECTS_LIMIT);

  return (
    <section className={styles.section} aria-labelledby="home-recent-projects">
      <h2 className={styles.heading} id="home-recent-projects">
        Recent Projects
      </h2>

      <ul className={styles.list}>
        {recentMaps.map((map) => {
          const title = getTextFromHtml(map.general?.mapTitle) || 'Untitled Map';
          return (
            <li className={styles.card} key={map.id}>
              <button type="button" className={styles.cardButton} onClick={() => navigate(generatePath(AppRoutes.MAP_VIEW, { id: String(map.id) }))}>
                <span className={styles.title}>{title}</span>
                <div className={styles.thumbnail}>
                  <img className={styles.image} src={map.general?.thumbnailImage || PROJECT_THUMBNAIL_PLACEHOLDER} alt={title} />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default RecentProjects;
